/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ICONS from "../../../../assets/Icons/index.js";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import RecreatePromptModalPopup from "../../../../components/_utils/RecreatePromptModalPopup/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import InternalTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import InternalAccountDetailsPopup from "../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import InternalTransactionDetailsPopup from "../../../../components/Transactions/InternalTransaction/InternalTransactionDetailsPopup/index.jsx";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  ownerAccountsBalanceRefresh,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  internalTransactionsActionable,
  internalTransactionsAddLabel,
  internalTransactionsApprove,
  internalTransactionsDetailsById,
  internalTransactionsReject,
  internalTransactionsRemoveLabel,
} from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";

const InternalTransactionSingleApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const [selectedLabels, setSelectedLabels] = useState([]);
  const [labels, setLabels] = useState([]);
  const [openRecreateModel, setopenRecreateModel] = useState(false);
  const [recreateId, setRecreateId] = useState("");
  const [loadingBox, setLoadingBox] = useState(false);
  const [page, setPage] = useState(1);
  const [showInternalDeclinePopup, setShowInternalDeclinePopup] =
    useState(false);
  const [rejectId, SetRejectId] = useState(null);
  const [loading, setLoading] = useState({});
  const [, setbtnClicked] = useState({});
  const [internalAccDetailOpen, setInternalAccDetailOpen] = useState(false);
  const [internalAccountid, SetInternalAccountid] = useState([]);
  const [, setrefreshAnimation] = useState("");
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= 3840 ? 192 : 50,
  );
  const [allInternalTxnAcc, setAllInternalTxnAcc] = useState([]);
  const [internalTxnLoading, setInternalTxnLoading] = useState(false);
  const [, setPrevBalance] = useState(null);
  const [toggle] = useState(true);
  const [realTimelineState, setRealTimelineState] = useState(null);
  const [showInternalTxnDetailPop, setShowInternalTxnDetailPop] =
    useState(false);
  const [txnId, setTxnId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [mainData, setMainData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [, setIsOpen] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [labelTxnId, setLabelTxnId] = useState([]);
  const [, setTimelineTxnId] = useState(null);
  const [openTimelinePopup, setOpenTimelinePopup] = useState(false);
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);
  const [showSearchBar] = useState(false);
  const [whichBtnClicked, setWhichBtnClicked] = useState({});

  const { services } = useSelector((state) => state.refreshToken);
  const { internalTransactionsActionableData } = useSelector(
    (state) => state.internalTransactions,
  );
  const { ownerAccBalanceLoading } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const lengthVarForConditonOne = 1;

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const totalTransactionCount = Number(mainData?.total_count || 0);

  const hasPendingTransaction = allInternalTxnAcc?.some(
    (transaction) => transaction?.lifecycle_status === "pending",
  );

  const hasPendingInternalAccount = allInternalTxnAcc?.some(
    (transaction) =>
      transaction?.internal_account_approval_status === "pending",
  );

  const shouldShowTransactionBankingHoursAlert =
    totalTransactionCount > 0 &&
    hasPendingTransaction &&
    isOutsideBankingHoursNow;

  const shouldShowAccountBankingHoursAlert =
    totalTransactionCount > 0 &&
    hasPendingInternalAccount &&
    isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    shouldShowTransactionBankingHoursAlert ||
    shouldShowAccountBankingHoursAlert;

  const handleOpenPopup = (id) => {
    setShowInternalDeclinePopup(true);
    SetRejectId(id);
  };
  const handleClosePopup = () => {
    setWhichBtnClicked((p) => {
      return {
        ...p,
        [rejectId]: "none",
      };
    });

    setShowInternalDeclinePopup(false);
  };
  const openInternalTxnDetailModal = () => {
    setShowInternalTxnDetailPop(true);
  };

  const closeInternalTxnDetailModal = () => {
    setShowInternalTxnDetailPop(false);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailOpen(false);
  };

  const openTimelineCardPopup = async (txnId) => {
    setTimelineTxnId(txnId);
    setOpenTimelinePopup(true);

    setLoadingData(true);

    try {
      const res = await dispatch(
        internalTransactionsDetailsById({ id: txnId }),
      );

      if (res?.payload?.transaction) {
        setTimelineTxnDetails(res.payload.transaction);
      }
    } catch (error) {
      CommonToast({
        text: error || "Error fetching transaction details",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary_bg)",
          enabledTextColor: "var(--text_primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    } finally {
      setLoadingData(false);
    }
  };

  const handleMultiViewClick = () => {
    navigate(
      "/internal_transaction_dashboard/internal_transaction_multi_approval",
    );
  };

  const handleRefresh = async (e, id, prevBalance) => {
    e.stopPropagation();
    setrefreshAnimation(id);
    setPrevBalance(prevBalance);
    try {
      let response = await dispatch(ownerAccountsBalanceRefresh(id));

      if (response?.payload?.status === true) {
        let data = allInternalTxnAcc?.map((item) => {
          if (
            response?.payload.owner_accounts[0].owner_account_id ===
            item.owner_account_id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response.payload.owner_accounts[0].owner_account_balance,

              owner_account_balance_last_fetched_at:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });
        setAllInternalTxnAcc(data);
        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          dispatch(setshowsuccestoast());
        }, 250);
      } else {
        setTimeout(() => {
          toast.dismiss();
          const errorMessage =
            response?.payload?.response?.data?.errors?.base?.[0] ||
            response?.payload?.message ||
            "Something went wrong";

          CommonToast({
            text: errorMessage,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      throw error;
    }
  };

  const closeRecreateDeclineModal = () => {
    setopenRecreateModel(false);
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Transaction approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetInternalAccountid(id);
    setInternalAccDetailOpen(!internalAccDetailOpen);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllInternalTxnAcc(updatedAccounts);
  };

  const handleTxnApproval = async (id) => {
    setWhichBtnClicked((p) => {
      return {
        ...p,
        [id]: "approve",
      };
    });
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));

    setbtnClicked((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: "Approve",
    }));

    CommonToast({
      text: "Approving transaction",
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    const data = await dispatch(internalTransactionsApprove({ id }));

    let errorMessage = "";
    let lifecycleStatus = "";
    let distributionStatus = "";
    if (data?.payload?.status === 500) {
      setTimeout(() => {
        CommonToast({
          text: data?.payload?.error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalExtraLarger);
    }
    if (data?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VInternalTxn",
          },
        });
      }, 2000);
    } else if (data.payload.status !== 404 && data.payload.status !== 500) {
      const updatedData = allInternalTxnAcc?.map((item) => {
        if (item.txn_id === id) {
          if (
            data.payload.status === true &&
            data.payload.transactions[0].lifecycle_status === "approved"
          ) {
            lifecycleStatus = data.payload.transactions[0].lifecycle_status;
            distributionStatus =
              data.payload.transactions[0].distribution_lifecycle_status;
          } else if (
            data?.payload?.errors?.base[0]?.errors &&
            data?.payload?.errors?.base[0]?.errors[0]?.reason
          ) {
            errorMessage = data.payload.errors.base[0].errors[0].reason[0];
            if (
              data?.payload?.errors?.base[0]?.errors[0]?.reason.length >=
              lengthVarForConditonOne
            ) {
              let msgs = data.payload.errors.base[0].errors[0].reason;

              if (Array.isArray(msgs)) {
                msgs?.forEach((error) => {
                  if (data?.payload?.status === false) {
                    setTimeout(() => {
                      CommonToast({
                        text: error,
                        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                        variant: "var(--error)",
                        btnProps: {
                          isDisabled: false,
                          enabledTextColor: "var(--text-primary)",
                          enabledBgColor: "var(--primary-bg)",
                        },
                      });
                    }, IntervalConfiguration.intervalExtraLarger);
                  }
                });
              } else {
                if (data?.payload?.status === false) {
                  setTimeout(() => {
                    CommonToast({
                      text: msgs,
                      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                      variant: "var(--error)",
                      btnProps: {
                        isDisabled: false,
                        enabledTextColor: "var(--text-primary)",
                        enabledBgColor: "var(--primary-bg)",
                      },
                    });
                  }, IntervalConfiguration.intervalExtraLarger);
                }
              }
            }
          } else if (
            data?.payload?.errors?.base[0]?.errors &&
            data?.payload?.errors?.base[0]?.errors[0]?.reason
          ) {
            errorMessage =
              data.payload.errors.base[0].errors[0].reason ||
              data.payload.errors.base[0].errors[0].reason[0];
            if (
              data?.payload?.errors?.base[0]?.errors.length >
              lengthVarForConditonOne
            ) {
              let msgs = data.payload.errors.base[0].errors[0].reason;

              if (Array.isArray(msgs)) {
                msgs?.forEach((error) => {
                  if (data?.payload?.status === false) {
                    setTimeout(() => {
                      CommonToast({
                        text: error,
                        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                        variant: "var(--error)",
                        btnProps: {
                          isDisabled: false,
                          enabledTextColor: "var(--text-primary)",
                          enabledBgColor: "var(--primary-bg)",
                        },
                      });
                    }, IntervalConfiguration.intervalExtraLarger);
                  }
                });
              } else {
                if (data?.payload?.status === false) {
                  setTimeout(() => {
                    CommonToast({
                      text: msgs,
                      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                      variant: "var(--error)",
                      btnProps: {
                        isDisabled: false,
                        enabledTextColor: "var(--text-primary)",
                        enabledBgColor: "var(--primary-bg)",
                      },
                    });
                  }, IntervalConfiguration.intervalExtraLarger);
                }
              }
            }
            if (
              data?.payload?.errors?.base[0]?.errors.length >=
              lengthVarForConditonOne
            ) {
              let msgs = data.payload.errors.base[0].errors[0].reason;
              errorMessage = msgs;
            }
          } else if (data?.payload?.errors?.base[0]) {
            errorMessage = data.payload.errors.base[0];
            setTimeout(() => {
              CommonToast({
                text: errorMessage,
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                btnProps: {
                  isDisabled: false,
                  enabledTextColor: "var(--text-primary)",
                  enabledBgColor: "var(--primary-bg)",
                },
              });
            }, 3000);
          } else if (
            data.payload.status === true &&
            data.payload.transactions[0].lifecycle_status === "pending"
          ) {
            lifecycleStatus = "pendingOne";
          }

          return {
            ...item,
            last_updated_status:
              item.last_updated_status === "Created" &&
              data?.payload.status === true &&
              data.payload.transactions[0].last_updated_status === "Approved"
                ? "Approved"
                : "Created",

            lifecycle_status:
              data?.payload.status === true &&
              item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data?.payload.status === false
                ? errorMessage
                : "",

            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              data.payload.status === true &&
              loginid.employees.id ===
                data.payload.transactions[0].last_updated_user_id
                ? "true"
                : "false",
            distribution_lifecycle_status:
              item.distribution_lifecycle_status === "" &&
              data?.payload.status === true
                ? distributionStatus
                : "",
          };
        }

        return item;
      });
      setAllInternalTxnAcc(updatedData);
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
      setWhichBtnClicked((p) => {
        return {
          ...p,
          [id]: "none",
        };
      });
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (
        data?.payload?.status === true &&
        data.payload.transactions[GlobalConfiguration.lengthCheckZero]
          .lifecycle_status === "approved"
      ) {
        handleApprovalToastSuccess();
      }
      if (data.payload.status === errorcode.errorNotFound) {
        CommonToast({
          text: data.payload.error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleFilterCategory = () => {
    // setLabelSearchText(selectedLabels);
    setFilterOpen(false);
  };

  const handleClearFilters = () => {
    setLabelSearchText([]);
    setSearchUserTextDebounce("");
    setSelectedLabels([]);
    setPage(1);
  };

  const handleRecreateReject = async (reason) => {
    setLoadingBox(true);

    const data = await dispatch(
      internalTransactionsReject({ id: recreateId, rejection_reason: reason }),
    );
    toast.dismiss();
    CommonToast({
      text: "Rejecting transaction.",
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
    });
    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === errorcode.errorFailed) {
      toast.dismiss();
      CommonToast({
        text: data?.payload?.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else if (data?.payload?.status === false) {
      const error_msg =
        data?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.errors?.[GlobalConfiguration.lengthCheckZero] || "Unknown error";
      setopenRecreateModel(false);
      setLoadingBox(false);
      toast.dismiss();
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else {
      toast.dismiss();
      CommonToast({
        text: "Transaction rejected and sent for recreation.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      const updatedData = allInternalTxnAcc.map((item) => {
        if (item?.txn_id === recreateId) {
          return {
            ...item,
            lifecycle_status: "recreate",
            rejected: true,
            error: "false",
            rejection_reason: reason,
          };
        }
        return item;
      });
      setopenRecreateModel(false);
      updateAllAccounts(updatedData);
      setLoadingBox(false);
    }
  };

  async function onMount() {
    setInternalTxnLoading(true);

    try {
      const res = await dispatch(
        internalTransactionsActionable({
          page_no: page,
          page_size: pageSize,
          labels: LabelSearchText.length ? LabelSearchText : undefined,
          search: searchUserTextDebounce || undefined,
        }),
      );

      const txns = res?.payload?.transactions || [];

      setAllInternalTxnAcc(
        txns.map((t) => ({
          ...t,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })),
      );

      setMainData(res?.payload || {});
    } catch (e) {
      console.error(e);
    }

    setInternalTxnLoading(false);
  }

  const hasAnyFilter =
    (LabelSearchText &&
      LabelSearchText.length > GlobalConfiguration.lengthCheckZero) ||
    (searchUserTextDebounce &&
      searchUserTextDebounce.length > GlobalConfiguration.lengthCheckZero);

  const noTransactionsFromAPI =
    !internalTxnLoading &&
    mainData &&
    mainData.total_count === 0 &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !internalTxnLoading && allInternalTxnAcc.length === 0 && hasAnyFilter;

  const getDistributionTitle = (status) => {
    switch (status) {
      case "distribution_complete":
        return "Distribution completed!";
      case "approved":
        return "Distribution approved";
      case "created":
        return "Distribution created";
      case "awaiting_funds":
        return "Distribution awaiting funds";
      case "distribution_pending":
        return "Distribution pending";
      case "distribution_initiated":
        return "Distribution initiated";
      case "rejected":
        return "Distribution rejected";
      case "reversal":
        return "Distribution reversal";
      case "denied":
        return "Distribution denied";
      case "abandoned":
        return "Distribution abandoned";
      case "failed":
        return "Distribution failed";
      default:
        return "Unknown error";
    }
  };

  const getDistributionSubtext = (status) => {
    switch (status) {
      case "distribution_complete":
        return "This transaction has been verified and settled.";
      case "approved":
        return "The distribution for this transaction has been approved.";
      case "created":
        return "This transaction has been approved and is set for distribution";
      case "awaiting_funds":
        return "This transaction has been approved and awaiting for funds.";
      case "distribution_pending":
        return "The distribution for this transaction has been pending.";
      case "distribution_initiated":
        return "This transaction has been approved and the distribution is initiated.";
      case "rejected":
        return "The distribution for this transaction has been rejected.";
      case "denied":
        return "The distribution for this transaction has been denied.";
      case "reversal":
        return "The distribution for this transaction has been reversed.";
      case "failed":
        return "The distribution for this transaction has failed.";
      default:
        return "An error occurred while taking action on this transaction.";
    }
  };

  const getDistributionIcon = (status) => {
    switch (status) {
      case "created":
      case "approved":
      case "awaiting_funds":
      case "distribution_initiated":
      case "distribution_pending":
        return ICONS.QUEUED;

      case "distribution_complete":
        return ICONS.APPROVED_LINEAR;

      case "rejected":
      case "failed":
      case "reversal":
      case "denied":
        return ICONS.REJECTED_RED;

      case "abandoned":
        return ICONS.CLOSE_WITH_GREY_CIRCLE;
      default:
        return null;
    }
  };

  const getTxnOverlayConfig = ({
    internal,
    loading,
    openTxn,
    openAccountDrawer,
    openRecreatePopup,
    openTxn2,
  }) => {
    const isError =
      internal?.lifecycle_status === "error" &&
      internal?.error === "true" &&
      !loading[internal?.txn_id];

    const isRejected =
      internal?.lifecycle_status === "rejected" &&
      internal?.error === "false" &&
      !loading[internal?.txn_id];

    const isRecreate =
      internal?.lifecycle_status === "recreate" &&
      internal?.error === "false" &&
      !loading[internal?.txn_id];

    const isAccountApprovalPending =
      internal?.lifecycle_status === "pending" &&
      internal?.internal_account_approval_status === "pending" &&
      !loading[internal?.txn_id];

    const isTxnApprovalPending =
      (internal?.lifecycle_status === "pending" || loading[internal?.txn_id]) &&
      internal?.internal_account_approval_status === "approved";

    const isSecondApprovalPending =
      internal?.last_updated_user_id_check === "true" &&
      internal?.lifecycle_status === "pendingOne" &&
      internal?.error === "false" &&
      !loading[internal?.txn_id];

    const isDistributionState =
      internal?.lifecycle_status === "approved" &&
      [
        "created",
        "approved",
        "reversal",
        "denied",
        "awaiting_funds",
        "distribution_initiated",
        "distribution_pending",
        "rejected",
        "abandoned",
        "failed",
        "distribution_complete",
      ].includes(internal?.distribution_lifecycle_status) &&
      internal?.error === "false" &&
      !loading[internal?.txn_id];

    if (isError) {
      return {
        cardState: "single",
        overlay1icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        overlay1Text: "Approval not possible",
        overlay1Subtext: internal?.message,
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Text: "Send for recreation",
        overlay1Cta1OnClick: openRecreatePopup,
        allowApproveReject: false,
      };
    }

    if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: ICONS.REJECTED_RED,
        overlay1Text: "Rejected",
        overlay1Subtext: "This transaction has been rejected!",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay2Subtext: "Rejected reason",
        overlay2Text: internal?.rejection_reason,
        allowApproveReject: false,
      };
    }

    if (isRecreate) {
      return {
        cardState: "single",
        overlay1Icon: ICONS.RECREATE_RED,
        overlay1Text: "Rejected and sent for recreation",
        overlay1Subtext:
          "This transaction has been rejected and can now be recreated.",
        overlay1CtaText: "Recreate transaction dashboard",
        overlay1CtaOnClick: openTxn2,
        overlay1Cta1Text: "View transaction",
        overlay1Cta1OnClick: openTxn,
        allowApproveReject: false,
      };
    }

    const hasAccountApprovalAccess =
      services?.includes("IAAccount") && services?.includes("IVAccount");

    if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1Subtext:
          "Account is not approved, please approve account before approving transaction.",
        overlay1CtaText: "Approve account",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "IAAccount, IVAccount" },
            });
          }
        },

        allowApproveReject: false,
      };
    }

    if (isSecondApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: ICONS.PENDING,
        overlay1IconColor: "var(--pending)",
        overlay1Text: "Pending",
        overlay1Subtext:
          "This transaction has been approved and requires another user's approval before distribution.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    }

    if (isDistributionState) {
      return {
        cardState: "single",
        overlay1Icon: getDistributionIcon(
          internal?.distribution_lifecycle_status,
        ),
        overlay1Text: getDistributionTitle(
          internal?.distribution_lifecycle_status,
        ),
        overlay1Subtext: getDistributionSubtext(
          internal?.distribution_lifecycle_status,
        ),
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    }

    if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject:
          services?.includes("AInternalTxn") &&
          services?.includes("VInternalTxn"),
      };
    }

    return {
      cardState: "default",
      allowApproveReject: false,
    };
  };

  // useEffects

  useEffect(() => {
    if (timelineTxnDetails) {
      const uiState = addLifeCycleStatus({
        lifecycle_status: timelineTxnDetails?.lifecycle_status,
        distribution_lifecycle_status:
          timelineTxnDetails?.distribution_lifecycle_status,
        services,
      });
      const newData = timelineTxnDetails?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
        ...uiState,
      }));
      setRealTimelineState(newData);
      setTxnId(timelineTxnDetails?.[0]?.txn_id);
      SetInternalAccountid(timelineTxnDetails?.[0]?.internal_account_id);
    }
  }, [timelineTxnDetails]);

  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        if (filterOpen) {
          setFilterOpen(false);
        }
      }
    };
    document.addEventListener("click", handlefilter);

    return () => {
      document.removeEventListener("click", handlefilter);
    };
  }, [filterOpen]);

  useEffect(() => {}, [internalTransactionsActionableData]);

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Labels") {
      const available = JSON.parse(
        sessionStorage.getItem("internalTxnLabels") || "[]",
      );

      const search = searchUserTextDebounce.toLowerCase();

      const filtered = available.filter((label) =>
        label?.toLowerCase().includes(search),
      );

      setInputData(
        filtered.map((label) => ({
          id: label,
          Label: label,
        })),
      );
    }

    setLoadingData(false);
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    onMount();
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnId);
    const res = await dispatch(
      internalTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (internalTransactionsAddLabel.fulfilled.match(res)) {
      await onMount();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (internalTransactionsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (internalTransactionsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnId);
    const res = await dispatch(
      internalTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (internalTransactionsRemoveLabel.fulfilled.match(res)) {
      await onMount();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (internalTransactionsRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (internalTransactionsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handlePagination = (page) => {
    setPage(page);
  };

  useEffect(() => {
    const labelsFromApi = [];

    allInternalTxnAcc.forEach((txn) => {
      if (Array.isArray(txn.labels)) {
        labelsFromApi.push(...txn.labels);
      }
    });

    const existing = JSON.parse(
      sessionStorage.getItem("internalTxnLabels") || "[]",
    );

    const merged = Array.from(new Set([...existing, ...labelsFromApi]));

    sessionStorage.setItem("internalTxnLabels", JSON.stringify(merged));
  }, [allInternalTxnAcc]);

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    onMount();
  }, [page, pageSize, LabelSearchText, markerData]);

  useEffect(() => {
    if (showInternalDeclinePopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showInternalDeclinePopup]);

  useEffect(() => {
    dispatch(enableSwitcher());

    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("internalTxnLabels");
    const parsedLabels = JSON.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedLabels, filterOpen]);

  useEffect(() => {
    if (showInternalDeclinePopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showInternalDeclinePopup]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
  }, [ownerAccBalanceLoading]);

  return (
    <>
      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      {openTimelinePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center justify-center z-z-index-modal bg-opacity-dark-opacity bg-PopUp-BackDrop">
          <LargePopupRedirect
            headerTitle="Transaction timeline"
            closeiconhandleFunction={() => {
              setOpenTimelinePopup(false);
              setTimelineTxnId(null);
              setTimelineTxnDetails([]);
              setOpenApprovalTimeline([]);
            }}
            isscrollRequired={true}
          >
            {loadingData ? (
              <div className="flex justify-center items-center h-full">
                <Loader />
              </div>
            ) : (
              <TimelinePopupContent
                logsData={realTimelineState ?? timelineTxnDetails}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={true}
                showDistributionTimeline={false}
                openApprovalTimeline={openApprovalTimeline}
                openDistributionTimeline={openDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            )}
          </LargePopupRedirect>
        </div>
      )}

      {internalAccDetailOpen && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <InternalAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccountid}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}
      {openRecreateModel && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <RecreatePromptModalPopup
            loadingBox={loadingBox}
            inputDisabled={loadingBox}
            onConfirmBtnClick={handleRecreateReject}
            onCancelBtnClick={closeRecreateDeclineModal}
          />
        </div>
      )}
      {showInternalDeclinePopup && (
        <InternalTxnDeclinePopup
          handleClose={handleClosePopup}
          txnId={rejectId}
          flow={"internal_singleApproval"}
          allTxnData={allInternalTxnAcc}
          updateAllTxn={updateAllAccounts}
          addLifeCycleStatus={addLifeCycleStatus}
        />
      )}
      {isLabelPopupOpen && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsLabelPopupOpen(true);
          }}
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={allInternalTxnAcc
              ?.filter((t) => labelTxnId.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {showInternalTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalTransactionDetailsPopup
            closeInternalTxnDetailModal={closeInternalTxnDetailModal}
            internal_txn_id={txnId}
            type={"internal_txn_detail_modal"}
            error_msg={errorMessage}
            setErrorMessage={setErrorMessage}
            setShowInternalTxnDetailPop={setShowInternalTxnDetailPop}
          />
        </div>
      )}

      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <div className="z-z-index-overlay">
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={undefined}
            topNavCtaBtn2Needed={false}
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: toggle,
              isDisabled: showSearchBar,
              title: "Multi Approval",
              handleClick: () => handleMultiViewClick(),
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            BottomHeader="Post Approval Process"
            BottomSubText="Once approved, transaction distribution will get created and auto
              settled using selected source internal. If there are insufficient
              funds, the transaction will settle once the source account is
              refilled, and distribution will be initiated thereafter."
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: internalTxnLoading,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search internal transaction",
              filterPlaceholder: "Labels",
              filterItems: [
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setPage(1);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                },
              ],
              isSearchClearAllDisabled: !LabelSearchText?.length,
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div className="flex flex-col gap-gap-md pt-padding-md w-width-full px-padding-md overflow-x-hidden Qlg:px-padding-base overflow-y-auto pb-padding-md">
            {internalTxnLoading ? (
              <div className="w-width-full h-[calc(100vh-var(--navbar-height)-var(--pagination-height))] flex items-center justify-center">
                <Loader />
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-sm m-auto">
                <div>
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="no_pending_transaction"
                  />
                </div>
                <p className="text-sm text-text-primary">
                  There are no more transactions that require <br /> your
                  approval.
                </p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Internal transaction dashboard"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() =>
                    navigate("/internal_transaction_dashboard")
                  }
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-sm m-auto">
                <div>
                  <img src={ICONS?.NO_DATA_FOUND} alt="no data found" />
                </div>
                <p className="text-sm text-text-primary">No data found.</p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => {
                    handleClearFilters();
                  }}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              <>
                {shouldShowBankingHoursAlert && (
                  <div className="max-w-tab-width-normal w-full Qlg:mx-auto px-padding-md Qlg:px-padding-base">
                    <CommonAlertCard
                      title="Functioning outside banking hours"
                      texts="Transactions will be processed automatically during the next bank working day. Learn more"
                      highlightedText={["Learn more"]}
                      onHighlightedTextClick={(event, index) => {
                        if (index === 0) {
                          setShowBankingHoursPopup(true);
                        }
                      }}
                    />
                  </div>
                )}

                {internalTransactionsActionableData === undefined ||
                  allInternalTxnAcc?.map((internal) => {
                    const overlay = getTxnOverlayConfig({
                      internal,
                      loading,
                      openTxn: () => {
                        openInternalTxnDetailModal();
                        setTxnId(internal?.txn_id);
                      },
                      openRecreatePopup: () => {
                        setopenRecreateModel(true);
                        setRecreateId(internal?.txn_id);
                      },
                      openAccountDrawer: () =>
                        SideDrawerOpen(
                          internal?.internal_account_id,
                          internal?.txn_id,
                        ),
                      openTxn2: () => {
                        navigate(
                          "/internal_transaction_dashboard/recreate_internal_transaction_dashboard",
                        );
                        // CommonToast({
                        //   text: "Feature coming soon.",
                        //   icon: ICONS?.INFO,
                        //   variant: "var(--coming-soon)",
                        //   buttonNeeded: false,
                        // });
                      },
                    });

                    const alerts = [];

                    const entries = [
                      [
                        {
                          type: "textSubtext",
                          text: `INR ${FormatAmount({
                            price: internal?.amount || "0",
                          })}`,
                          subText: "Amount",
                          textColor: "var(--settled)",
                          icon: ICONS?.INTERNAL_WITH_WHITE_CIRCLE,
                          iconColor: "",
                          isBold: true,
                        },
                        {
                          type: "textSubtext",
                          text: internal?.internal_account_name,
                          subText: "Account name",
                          icon:
                            internal?.confidential_transaction === "Y"
                              ? ICONS.CONFIDENTIAL_TRANSACTION
                              : null,
                        },
                        {
                          type: "cta",
                          text: internal?.labels?.length
                            ? internal?.labels.join(", ")
                            : "No labels assigned",
                          subText: "Labels",
                          onClick: (e) => {
                            if (
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            ) {
                              e.stopPropagation();
                              setLabelTxnId([internal?.txn_id]);
                              setSelectedLabels(internal?.labels || []);
                              setIsLabelPopupOpen(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                            }
                          },
                        },
                      ],
                    ];

                    return (
                      <div
                        key={internal?.txn_id}
                        className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                      >
                        <CommonTransactionApprovalCard
                          whichBtnClicked={
                            whichBtnClicked?.[internal?.txn_id] ?? "none"
                          }
                          overrideAutoLoader
                          accountApprovalPending={
                            internal?.lifecycle_status === "pending" &&
                            internal?.internal_account_approval_status ===
                              "pending" &&
                            !loading[internal?.txn_id]
                          }
                          entries={entries}
                          alerts={alerts}
                          cardState={overlay.cardState}
                          overlay1Text={overlay.overlay1Text}
                          overlay1Subtext={overlay.overlay1Subtext}
                          overlay1CtaText={overlay.overlay1CtaText}
                          overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                          overlay1SubtextColor={
                            internal?.lifecycle_status === "pending" &&
                            internal?.internal_account_approval_status ===
                              "pending" &&
                            !loading[internal?.txn_id]
                              ? "var(--pending)"
                              : undefined
                          }
                          overlay1Cta1Text={overlay?.overlay1Cta1Text}
                          overlay1Cta1OnClick={overlay?.overlay1Cta1OnClick}
                          overlay1Cta1Color={overlay?.overlay1Cta1Color}
                          overlay2Text={overlay.overlay2Text}
                          overlay2Subtext={overlay.overlay2Subtext}
                          approveClick={() => {
                            if (overlay.allowApproveReject) {
                              handleTxnApproval(internal?.txn_id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService:
                                    "VInternalTxn,AInternalTxn",
                                },
                              });
                            }
                          }}
                          rejectClick={() => {
                            setWhichBtnClicked((p) => ({
                              ...p,
                              [internal?.txn_id]: "reject",
                            }));
                            if (overlay.allowApproveReject) {
                              handleOpenPopup(internal?.txn_id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService:
                                    "VInternalTxn,AInternalTxn",
                                },
                              });
                            }
                          }}
                          approveBtnText="Approve transaction"
                          rejectBtnText="Reject transaction"
                          ownerAccountNumber={
                            internal?.owner_account_bank_acc_no
                          }
                          ownerAccountIfsc={internal?.owner_account_ifsc_code}
                          ownerAccountNumberSubtext="Source account"
                          ownerAccountBalance={internal?.owner_account_balance}
                          ownerAccountBalanceSubtext={
                            internal?.owner_account_balance_last_fetched_at_in_words
                          }
                          ownerAccountBalanceOnClick={(e) =>
                            handleRefresh(
                              e,
                              internal?.owner_account_id,
                              internal?.owner_account_balance,
                            )
                          }
                          destinationAccountNumber={
                            internal?.internal_account_bank_acc_no
                          }
                          destinationAccountIfsc={
                            internal?.internal_account_ifsc_code
                          }
                          destinationAccountNumberSubtext="Destination account"
                          destinationAccountText={
                            internal?.internal_account_ifsc_code
                          }
                          destinationAccountSubtext="IFSC code"
                          thisIsARecreateCard={
                            internal?.lifecycle_status === "recreate"
                          }
                          recreateBtnText="Recreate this transaction"
                          recreateOnClick={() => {
                            setRecreateId(internal?.txn_id);
                            setopenRecreateModel(true);
                          }}
                          ctaBtn1Text="Additional details"
                          ctaBtn1OnClick={() => {
                            openInternalTxnDetailModal();
                            setTxnId(internal?.txn_id);
                          }}
                          ctaBtn2Text="Transaction history"
                          ctaBtn2OnClick={() =>
                            openTimelineCardPopup(internal?.txn_id)
                          }
                          overlay1Icon={overlay.overlay1Icon}
                          overlay1IconColor={overlay.overlay1IconColor}
                        />
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
        {!internalTxnLoading &&
          mainData?.total_count > GlobalConfiguration?.lengthCheckZero && (
            <div className="w-full z-z-index-tooltip relative">
              {showInnerSearchBar && (
                <div className="absolute inset-top-base bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header"></div>
              )}
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={page}
                setIsOpen={setIsOpen}
              />
            </div>
          )}
      </div>
    </>
  );
};

export default InternalTransactionSingleApproval;
